import { c as _c } from "react/compiler-runtime";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import Image from 'next/image';
import Link from 'next/link';
dayjs.extend(relativeTime);
export function RelatedPostModel(t0) {
  const $ = _c(15);
  const {
    tags,
    recentPost,
    isMobile
  } = t0;
  const t1 = ` ${isMobile ? "flex flex-col gap-10" : ""} `;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="py-4 text-xl">Recent Articles</h2>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `${isMobile ? "flex h-fit w-fit gap-10" : "flex-row-4 flex"} md:justify-around md:gap-4 lg:justify-between `;
  let t4;
  if ($[1] !== recentPost) {
    t4 = recentPost.map(_temp);
    $[1] = recentPost;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = <div className="padding-adjust">{t2}<div className="overflow-x-scroll"><div className={t3}>{t4}</div></div></div>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h2 className="text-xl">Tags</h2>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== tags) {
    t7 = tags?.map(_temp2);
    $[7] = tags;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7) {
    t8 = <div className="padding-adjust pt-3">{t6}<div className="tagline gap-3 py-2">{t7}</div></div>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t1 || $[12] !== t5 || $[13] !== t8) {
    t9 = <><div className={t1}>{t5}{t8}</div></>;
    $[11] = t1;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}
function _temp2(tag) {
  return <Link key={tag.id} href={`/blog/tag/${tag.slug}`} className="cursor-pointer py-1 pr-2 text-xs hover:text-blue-600 lg:whitespace-nowrap lg:px-2">{tag.name}</Link>;
}
function _temp(post) {
  return <Link key={post.id} href={`/blog/${post.slug}`}><div className="flex w-[230px] cursor-pointer flex-col space-y-2"><div className="h-[140px] w-full overflow-hidden rounded-xl"><Image src={`/images/blog/icons/${post.slug}.${post.feature_image?.split(".").pop()}`} alt={post.title} className="rounded-xl fill-current" width={230} height={140} /></div><span className="two-line-clamp overflow-hidden py-1 text-sm">{post.title}</span><span className="py-2 pb-4 text-xs">{dayjs(post.published_at).fromNow() || "a few seconds ago"}</span></div></Link>;
}